import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LETTERING_ACTION, RegisterGateService } from '@app/sales/periods/register-gate.service';

// Saisie NEUVE seulement (comptoir/commande/rent, route nue) : sans caisse ouverte sur le poste, on renvoie sur /sales/periods
// avant d'ouvrir l'écran. Une pièce existante (/sales/quotation/:id, id > 0) se consulte sans caisse : voir registerOpenIfNewGuard.
export const registerOpenGuard: CanActivateFn = (): Observable<boolean> => openOrRedirect();

// Lettrage bancaire (JP 24/10) : même garde que la saisie neuve ; le serveur refuse en plus chaque mode remis en main propre sans session.
export const letteringOpenGuard: CanActivateFn = (): Observable<boolean> => openOrRedirect(LETTERING_ACTION);

function openOrRedirect(action?: string): Observable<boolean> {
  const gate = inject(RegisterGateService);

  return gate.check$(action).pipe(
    map(verdict => {
      if (verdict.open) return true;
      gate.redirectToPeriods(verdict);
      return false;
    }),
  );
}

// :id « 0 », « null » ou texte : QuotationComponent y ouvre une saisie neuve, donc même contrôle (un négatif aussi, par prudence).
export const registerOpenIfNewGuard: CanActivateFn = (route, state) =>
  Number(route.paramMap.get('id')) > 0 ? true : registerOpenGuard(route, state);
